import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PoModule } from '@po-ui/ng-components';
import { PoTemplatesModule } from '@po-ui/ng-templates';

import { SonarExtractorComponent } from './sonar-extractor.component';
import { SonarExtractorDashboardComponent } from './components/sonar-extractor-dashboard/sonar-extractor-dashboard.component';
import { SonarExtractorIssuesComponent } from './components/sonar-extractor-issues/sonar-extractor-issues.component';
import { SonarExtractorReportsComponent } from './components/sonar-extractor-reports/sonar-extractor-reports.component';
import { SonarExtractorRunsComponent } from './components/sonar-extractor-runs/sonar-extractor-runs.component';
import { SonarExtractorDatastudioComponent } from './components/sonar-extractor-datastudio/sonar-extractor-datastudio.component';
import { SonarExtractorReleasesComponent } from './components/sonar-extractor-releases/sonar-extractor-releases.component';
import { SonarExtractorProjectsComponent } from './components/sonar-extractor-projects/sonar-extractor-projects.component';

@NgModule({
  declarations: [
    SonarExtractorComponent,
    SonarExtractorDashboardComponent,
    SonarExtractorIssuesComponent,
    SonarExtractorReportsComponent,
    SonarExtractorRunsComponent,
    SonarExtractorDatastudioComponent,
    SonarExtractorReleasesComponent,
    SonarExtractorProjectsComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    PoModule,
    PoTemplatesModule,
  ],
  providers: [],
})
export class SonarExtractorModule {}
